import { Component, OnInit, Input } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { DisplayService } from '../../services/display/display.service';
import { UserService } from '../../services/user/user.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';

@Component({
	selector: 'pcm-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

	@Input() title = '';
	@Input() path = '';
	@Input() prefix = '';
	@Input() suffix = '';
	@Input() count = 0;
	@Input() cleared = false;

	pendingTimesheets = 0;
	pendingContractors = 0;
	pendingPOContractors = 0;
	pendingPORenewals = 0;
	lowFundsPO = 0;
	// for contractor
	contractorSavedTimesheets = 0;
	contractorRejectedTimesheets = 0;
	contractorPendingTimesheets = 0;

	constructor(
		private commsService: CommsService,
		private displayService: DisplayService,
		public userService: UserService,
		public timesheetService: TimesheetService
	) { }

	ngOnInit() {
		if (this.userService.persona === 'contractor' && this.timesheetService.pathToTimesheet === 'timesheet') {
			this.timesheetService.getPathToTimesheet();
		}

		this.loadDashBoard();
	}

	loadDashBoard() {
		this.displayService.startLoading();
		this.commsService.getDashBoard().subscribe((res) => {
			console.log('LOAD Dashboard: ', res);
			this.displayService.endLoading();
			const successData = this.commsService.getSuccessData(res);
			this.pendingTimesheets = successData['CONTRACTORTIMESHEET-APPROVALPENDING'];
			this.pendingContractors = successData['CONTRACTORINFO-APPROVALPENDING'];
			this.pendingPOContractors = successData['SUPPLIERCONTRACT-CONTRACTORPENDING'];
			this.pendingPORenewals = successData['SUPPLIERCONTRACT-RENEWALPENDING'];
			this.lowFundsPO = successData['PO-LOW-FUNDS'];
			this.contractorSavedTimesheets = successData['CONTRACTOR-TIMESHEET-SAVED'];
			this.contractorRejectedTimesheets = successData['CONTRACTOR-TIMESHEET-REJECTED'];
			this.contractorPendingTimesheets = successData['CONTRACTOR-TIMESHEET-PENDING'];
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('Load Dashboard', err);
		});
	}
}
